module.exports = __webpack_public_path__ + "media/images/icons/arrow-bottom-63de192c93a48b57a14a2a0e9b43c95e.svg";